export default {
  zh: {
    plaza: 'CP',
    rank: '排行榜',
    reward: '奖励',
    week: '本周排行',
    title: 'CP互相赠送礼物（超过1800金币）会展示在cp广场',
    last: '上周排行',
    previous: '以往CP第一名',
    remark: '发送礼物"求婚",就可以成为cp,只有互相赠送cp礼物才会增加cp积分',
    cp: '是否取消CP（取消后所有积分清零）',
    cancel: '取消',
    confirm: '确定',
    clear: '取消',
    totalScore: '总积分（不仅是这周）',
    service: '如果有疑问，点击这里联系客服',
    rewardtitle: '规则',
    rule: 'Rules',
    rewardRule: `
    - 关于头像框和座驾：可以从用户获胜的任何位置拿走头像框和座驾<br/><br/>
    - 关于徽章：徽章只能在完成用户获胜中心的积分的情况下获得，不能兑换其他中心的任何徽章<br/><br/>
    - 关于金币：如果用户赢了其中一个名次，比如（某用户赢了第一名，但是他的积分只有500k，意味着小于800k。在这种情况下，他将获得第一名头像框+第一名座驾+第一名徽章+第二名的金币，因为他满足了超过400k的第二名的金币条件）<br/><br/>
    但是如果第一名的积分小于500k，比如只有400k，那意味着比获得第一名的徽章的条件还低，在这种情况下，他将只获得第一名的头像框和座驾，没有徽章奖励。
    <br/>其他礼物不会影响您的CP分数，只有CP礼物可以提高您的活动分数`,
    yy: '为了庆祝情人节，在活动期间,赠送情人节特别礼物（ run to you），也可以成为cp，这周前三名将会有额外奖励，祝大家情人节快乐 。',
    days: 'days',
  },
  ar: {
    cancel: 'يلغي',
    confirm: 'نعم',
    clear: 'يلغي',
    rule: 'القواعد',
    rewardtitle: 'حكم',
    successful: "العملية كانت ناجحه",
    rewardRule: `<br/>١- اثناء الحدث، يمكن للجميع رفع مستوى التصنيف من خلال ارسال الهدايا المخصصة للحدث 
    <br/>٢- اعلى ثلاثه مشاركين في التصنيف سيحصلوا على جوائز سخية 
    <br/> ٣- سيحصل بقية المشاركين الذين يصل مستوى تصنيفهم 200الف على جوائز ايضا`,
    prize: "الجوائز",
    tipText:"اثناء فترة الحدث، ارسل الهدايا المخصصه للحدث للإشتراك في التصنيف",
    timeR: 'العد التنازلي',
    days: 'أيام',
    topOneText:"(المركز الاول (200 الف نقطة واكثر",
    topTwoText:"(المركز الثاني (200 الف نقطة واكثر",
    topThreeText:"(المركز الثالث (200 الف نقطة واكثر",
    topFourText:"المركز الرابع وأقل (200 الف نقطة واكثر)",
  },
  en: {
    successful: "The operation was successful",
    cancel: 'No',
    confirm: 'Yes',
    clear: 'Cancel',
    rule: 'Rules',
    rewardtitle: 'Rules',
    rewardRule: `1. During the event, users can increase their ranking value by sending the  special gifts for the event. <br/>
    2. Ranking  Top 3 users  will receive generous rewards.<br/>
    3. For users ranked 4th and above, they will also receive rewards as long as their rank value reaches 200K.`,
    prize: "Prize",
    tipText:"During the event, give the following gifts to participate in the rankings.",
    timeR: 'Count down: ',
    days: 'days',
    topOneText:"Top 1 (Points > 200k)",
    topTwoText:"Top 2 (Points > 200k)",
    topThreeText:"Top 3 (Points > 200k)",
    topFourText:"Top 4 and below (Points > 200k)",
  },
  tr: {
    rule: 'Kural',
    cancel: 'No',
    confirm: 'Yes',
    clear: 'Ayrıl',
    successful: "İşlem Başarılı Oldu",
    rewardtitle: 'Kurallar',
    rewardRule: `1. Etkinlik sırasında kullanıcılar, etkinliğe özel hediyeler göndererek sıralama değerlerini yükseltebilirler.<br/>
    2. Sıralamada ilk 3'e giren kullanıcılar cömert ödüller alacaktır.<br/>
    3. 4. ve üzeri sıradaki kullanıcılar, sıra değerleri 200K'ya ulaştığı sürece ödüller alacaklardır.`,
    prize: "Ödül",
    tipText:"Etkinlik sırasında, sıralamaya katılmak için aşağıdaki hediyeleri gönderin.",
    timeR: 'Kalan süre: ',
    days: 'gün',
    topOneText:"En İyi 1 (Puan 200k)",
    topTwoText:"En İyi 2 (Puan 200k)",
    topThreeText:"En İyi 3 (Puan 200k)",
    topFourText:"İlk 4 ve Aşağısı (200k ve üstü)",
  },
}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/topLovers/lang.js